import { Tooltip as BoostrapTooltip } from 'bootstrap'

export default class Tooltip extends BoostrapTooltip {
    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new Tooltip(element))
    }
}
